export default {
  first: 'Strona główna',
  second: 'O nas',
  login: 'Logowanie',
};
